document.addEventListener('DOMContentLoaded', () => {
  const key = 'wishlistProducts';

  const getWishlist = () => JSON.parse(localStorage.getItem(key)) || [];
  const saveWishlist = (list) => localStorage.setItem(key, JSON.stringify(list));

  const headerCount = document.getElementById('wishlist-count');
  const headerIcon = document.getElementById('wishlist-icon');

  function updateHeader() {
    const list = getWishlist();
    if (!headerCount) return;
    if (!list || list.length === 0) {
      headerCount.setAttribute('hidden', '');
      headerCount.querySelector('span').textContent = '0';
      if (headerIcon) headerIcon.classList.remove('active');
    } else {
      headerCount.removeAttribute('hidden');
      headerCount.querySelector('span').textContent = list.length < 100 ? list.length : '99+';
      if (headerIcon) headerIcon.classList.add('active');
    }
  }

  function setButtonState(btn) {
    const handle = btn.dataset.productHandle;
    if (!handle) return;
    const list = getWishlist();
    btn.classList.toggle('active', list.includes(handle));
  }

  function toggleHandle(handle) {
    const list = getWishlist();
    const i = list.indexOf(handle);
    const wasRemoved = i > -1;
    if (i > -1) list.splice(i, 1);
    else list.push(handle);
    saveWishlist(list);
    
    // Dispatch custom event for wishlist page to listen to
    window.dispatchEvent(new CustomEvent('wishlistChanged', {
      detail: { handle, removed: wasRemoved, added: !wasRemoved }
    }));
    
    return list;
  }

  function attachToButton(btn) {
    if (!btn) return;
    if (btn.__wishlistInit) return; // avoid double-binding
    btn.__wishlistInit = true;
    setButtonState(btn);
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      // Get the button element (in case click was on child element like SVG)
      const button = e.currentTarget;
      const handle = button.dataset.productHandle;
      
      if (!handle) {
        console.warn('Wishlist button missing data-product-handle attribute');
        return;
      }
      
      toggleHandle(handle);
      // update all buttons with same handle
      document.querySelectorAll(`.wishlist-button[data-product-handle="${handle}"]`).forEach(setButtonState);
      updateHeader();
    });
  }

  // attach to existing buttons
  document.querySelectorAll('.wishlist-button').forEach(attachToButton);
  updateHeader();

  // observe DOM for dynamically added buttons (product sections, AJAX, etc.)
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (!m.addedNodes) continue;
      m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.wishlist-button')) attachToButton(node);
        const children = node.querySelectorAll && node.querySelectorAll('.wishlist-button');
        if (children && children.length) children.forEach(attachToButton);
      });
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // listen to storage events (other tabs)
  window.addEventListener('storage', (e) => {
    if (e.key !== key) return;
    document.querySelectorAll('.wishlist-button').forEach(setButtonState);
    updateHeader();
  });
});
